import React from "react";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import {
  Comparator,
  dateFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../services/CamplaCoreService";
import Button from "react-bootstrap/Button";
import StorageService from "../../services/StorageService";

import {
  ButtonGroup,
  Col,
  Container,
  Row,
  ToggleButton,
} from "react-bootstrap";
import { Translation, withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faPlus, faStore } from "@fortawesome/free-solid-svg-icons";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import InstanceTemplateActionCell from "./instanceTemplateActionCell/InstanceTemplateActionCell";
import InstanceTemplateDialog from "./dialogs/instanceTemplateDialog/InstanceTemplateDialog";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import { Link } from "react-router-dom";
import DeleteDialog from "../../components/dialogs/deleteDialog/DeleteDialog";
import DateTimeHelper from "../../helpers/DateTimeHelper";
import PaginationTableFilterToggle from "../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class InstanceTemplates extends React.Component {
  tableId = "instanceTemplatesTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      instanceTemplates: [],
      networkProfiles: [],
      softwareCatalogs: [],
      configurationTemplates: {},
      isSaving: false,
      showCreateModal: false,
      showDeleteModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      cloneItemId: null,
      instanceTemplateToDeleteOrEdit: null,
      errorMessage: "",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
      validationResult: "",
    };

    this.loadData = this.loadData.bind(this);
    this.loadCachedData = this.loadCachedData.bind(this);
    this.handleCreateInstanceTemplate = this.handleCreateInstanceTemplate.bind(
      this
    );
    this.handleDeleteInstanceTemplate = this.handleDeleteInstanceTemplate.bind(
      this
    );
    this.hideCreationDialog = this.hideCreationDialog.bind(this);
    this.onHideCreationDialog = this.onHideCreationDialog.bind(this);
    this.onHideUpdateDialog = this.onHideUpdateDialog.bind(this);
    this.handleClone = this.handleClone.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();
    this.loadCachedData();
    this.setState(await this.loadData());
  }

  async assignSoftwareCatalogsToTemplate(instanceTemplateId, softwareCatalogs) {
    for (const catalog of softwareCatalogs) {
      const payload = {
        instanceTemplateId: instanceTemplateId,
        softwareCatalogId: catalog._id,
      };
      await CamplaCoreService.createTemplateSoftware(payload);
    }
  }

  async handleCreateInstanceTemplate(instanceTemplateToCreate) {
    try {
      this.setState({ isSaving: true });
      instanceTemplateToCreate.configuration = btoa(
        instanceTemplateToCreate.configuration
      );
      let createdInstanceTemplate = await CamplaCoreService.createInstanceTemplate(
        instanceTemplateToCreate
      );
      await this.assignSoftwareCatalogsToTemplate(
        createdInstanceTemplate._id,
        instanceTemplateToCreate.softwareCatalogs
      );
      this.state.instanceTemplates.push(createdInstanceTemplate);
      const updatedInstanceTemplates = [...this.state.instanceTemplates];
      StorageService.set("instanceTemplates", updatedInstanceTemplates);
      this.setState({
        isSaving: false,
        showCreateModal: false,
        instanceTemplates: updatedInstanceTemplates,
        dialogApiError: "",
        validationResult: "",
      });
    } catch (err) {
      this.setState({ isSaving: false });
      const result = await CamplaCoreService.validateInstanceTemplate(
        instanceTemplateToCreate
      );
      if (result.valid) {
        this.showApiError(err);
      } else {
        this.setState({
          validationResult: result.report.init_error,
        });
      }
    }
  }

  showApiError(err) {
    this.setState({
      dialogApiError: APIErrorHelper.getError(
        err,
        () => this.setState({ dialogApiError: "", validationResult: "" }),
        {
          PRECONDITION_FAILED: "InstanceTemplates.APIError.PreconditionFailed",
          CONFLICT: "InstanceTemplates.APIError.CreateConflict",
        },
        this.props.t
      ),
    });
  }

  async handleDeleteInstanceTemplate() {
    try {
      await CamplaCoreService.deleteInstanceTemplate(
        this.state.instanceTemplateToDeleteOrEdit._id
      );
      const updatedInstanceTemplates = this.state.instanceTemplates.filter(
        (x) => x._id !== this.state.instanceTemplateToDeleteOrEdit._id
      );
      StorageService.set("instanceTemplates", updatedInstanceTemplates);
      this.setState({
        showDeleteModal: false,
        instanceTemplates: updatedInstanceTemplates,
        instanceTemplateToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "InstanceTemplates.APIError.PreconditionFailed",
            NOT_FOUND: "InstanceTemplates.APIError.NotFound",
            CONFLICT: "InstanceTemplates.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  loadCachedData() {
    const instanceTemplates = StorageService.getReferenceType(
      "instanceTemplates"
    );
    const networkProfiles = StorageService.getReferenceType("networkProfiles");
    const configurationTemplates = StorageService.getReferenceType("configurationTemplates");
    const softwareCatalogs = StorageService.getReferenceType(
      "softwareCatalogs"
    );
    if (instanceTemplates) {
      this.setState({
        instanceTemplates,
      });
    }
    if (networkProfiles) {
      this.setState({
        networkProfiles,
      });
    }
    if (softwareCatalogs) {
      this.setState({
        softwareCatalogs,
      });
    }
    if (configurationTemplates) {
      this.setState({
        configurationTemplates,
      });
    }
  }

  async loadData() {
    try {
      const instanceTemplates = await CamplaCoreService.getAllInstanceTemplates();
      const networkProfiles = await CamplaCoreService.getAllNetworkProfiles();
      const softwareCatalogs = await CamplaCoreService.getAllSoftwareCatalogs();
      const configurationTemplates = await CamplaCoreService.getInstanceTemplateConfigurations();
      StorageService.set("instanceTemplates", instanceTemplates);
      StorageService.set("networkProfiles", networkProfiles);
      StorageService.set("softwareCatalogs", softwareCatalogs);
      StorageService.set("configurationTemplates", configurationTemplates);
      return {
        instanceTemplates,
        networkProfiles,
        softwareCatalogs,
        configurationTemplates
      };
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
    return {
      instanceTemplates: [],
      networkProfiles: [],
      softwareCatalogs: [],
      configurationTemplates: {}
    };
  }

  hideCreationDialog() {
    this.setState({ showCreateModal: false });
  }

  async handleClone(instanceTemplate) {
    try {
      this.setState({ cloneItemId: instanceTemplate._id });
      let createdInstanceTemplate = await CamplaCoreService.cloneInstanceTemplate(instanceTemplate._id);
      const updatedInstanceTemplates = [...this.state.instanceTemplates, createdInstanceTemplate];
      StorageService.set("instanceTemplates", updatedInstanceTemplates);
      this.setState({
        cloneItemId: null,
        instanceTemplates: updatedInstanceTemplates,
      });
    } catch (err) {
      this.setState({
        cloneItemId: null,
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t
        ),
      });
    }
  }

  onHideCreationDialog(isFormDirty) {
    if (isFormDirty) {
      this.setState({
        showUnsavedChangesDialog: true,
        closeAction: this.hideCreationDialog,
      });
    } else {
      this.hideCreationDialog();
    }
  }

  onHideUpdateDialog(isFormDirty) {
    if (isFormDirty) {
      this.setState({
        showUnsavedChangesDialog: true,
        closeAction: this.hideUpdateDialog,
      });
    } else {
      this.hideUpdateDialog();
    }
  }

  render() {
    const { t } = this.props;
    const columns = [
      {
        dataField: "name",
        text: t("InstanceTemplates.ColumnName"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          placeholder: t("InstanceTemplates.FilterNamePlaceholder"),
        }),
        formatter: (name, instanceTemplate) => (
          <Link
            className="item-link"
            to={{
              pathname: `/instanceTemplates/${instanceTemplate._id}`,
              state: {
                instanceTemplate: instanceTemplate,
              },
            }}
          >
            {name}
          </Link>
        ),
      },
      {
        dataField: "isPublished",
        text: t("InstanceTemplates.ColumnIsPublished"),
        formatter: this.getIsPublishedValue,
        sort: true,
        filter: selectFilter({
          options: [
            { value: true, label: t("InstanceTemplates.IsPublished") },
            { value: false, label: t("InstanceTemplates.IsNotPublished") },
          ],
          style: { display: this.state.displayFilter },
          placeholder: t("InstanceTemplates.FilterIsPublishedPlaceholder"),
        }),
      },
      {
        dataField: "updated_at",
        text: t("InstanceTemplates.ColumnUpdatedAt"),
        sort: true,
        formatter: (cell) => DateTimeHelper.formatDate(cell),
        filter: dateFilter({
          style: { display: this.state.displayFilter },
          defaultValue: { date: undefined, comparator: Comparator.EQ },
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatExtraData: this.state.cloneItemId,
        formatter: (action, instanceTemplate) => {
          return (
            <InstanceTemplateActionCell
                item={instanceTemplate}
                cloneItemId={this.state.cloneItemId}
                onClone={() => this.handleClone(instanceTemplate)}
                onDelete={() => {
                  this.setState({
                    showDeleteModal: true,
                    instanceTemplateToDeleteOrEdit: Object.assign({}, instanceTemplate),
                  });
              }}
            />
          );
        },
      },
    ];

    return (
      <div>
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <DeleteDialog
          show={this.state.showDeleteModal}
          onHide={() => this.setState({ showDeleteModal: false })}
          onSubmit={this.handleDeleteInstanceTemplate}
          dialogApiError={this.state.dialogApiError}
          title={t("InstanceTemplates.DeleteModal.Title")}
          body={t("InstanceTemplates.DeleteModal.Text", {
            instanceTemplateName: this.state.instanceTemplateToDeleteOrEdit
              ?.name,
          })}
          rightButtonText={t("InstanceTemplates.DeleteModal.Confirm")}
          leftButtonText={t("DialogCancel")}
        />
        <InstanceTemplateDialog
          title={t("InstanceTemplates.CreateModal.Title")}
          show={this.state.showCreateModal}
          onHide={this.onHideCreationDialog}
          onSubmit={this.handleCreateInstanceTemplate}
          isSaving={this.state.isSaving}
          dialogApiError={this.state.dialogApiError}
          networkProfiles={this.state.networkProfiles}
          softwareCatalogs={this.state.softwareCatalogs}
          configurationTemplates={this.state.configurationTemplates}
          validationResult={this.state.validationResult}
        />

        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("InstanceTemplates.Title")}</h2>
            </Col>
            <Col>
              <div style={{ float: "right" }}>
                <Button
                  className="btn-black mr-3"
                  as={Link}
                  to={{
                    pathname: `/templateMarketplace`,
                  }}
                >
                  <FontAwesomeIcon icon={faStore} />
                </Button>

                <Button
                  className="btn-green"
                  onClick={() => this.setState({ showCreateModal: true })}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                data={this.state.instanceTemplates}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
                view="instanceTemplates"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  getIsPublishedValue = (isPublished) => (
    <Translation>
      {(t, { i18n }) => {
        if (isPublished) {
          return t("InstanceTemplates.IsPublished");
        }
        return t("InstanceTemplates.IsNotPublished");
      }}
    </Translation>
  );
}

export default withTranslation()(InstanceTemplates);
